import { createAuthClient } from 'better-auth/client';

// Browser-side Better Auth client. Talks to /api/auth/* on the same origin
// (so cookies are first-party). The tenant subdomain we're on becomes the
// cookie scope automatically (advanced.crossSubDomainCookies in the server).

export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : '',
});

export type Session = NonNullable<Awaited<ReturnType<typeof authClient.getSession>>['data']>;
